import { render } from "./gradeDetailsView.vue?vue&type=template&id=739ec0a1"
import script from "./gradeDetailsView.vue?vue&type=script&lang=js"
export * from "./gradeDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__